import { ChartDrawOption } from '@/modules/ta/widget/models/drawoptions/ChartDrawOption';
import {
  PivotDefaultEmptyValueRepresentation,
  PivotDefaultTextOverflow,
  PivotMaxRows,
} from '@/modules/core/charts/pivottable/pivottable.constants';

export class PivotTableChartDrawOption extends ChartDrawOption {
  pivot_row_dimensions;

  pivot_column_dimensions;

  pivot_show_grand_totals_row;

  pivot_show_grand_totals_col;

  pivot_show_totals;

  pivot_empty_value;

  pivot_max_rows;

  pivot_text_overflow;

  pivot_alternating_row_color;

  pivot_font_size;

  constructor(model = {}) {
    super(model);

    this.pivot_row_dimensions = model.pivot_row_dimensions ?? [];
    this.pivot_column_dimensions = model.pivot_column_dimensions ?? [];
    this.pivot_show_grand_totals_row = model.pivot_show_grand_totals_row ?? false;
    this.pivot_show_grand_totals_col = model.pivot_show_grand_totals_col ?? false;
    this.pivot_show_totals = model.pivot_show_totals ?? false;
    this.pivot_empty_value = model.pivot_empty_value ?? PivotDefaultEmptyValueRepresentation;
    this.pivot_max_rows = model.pivot_max_rows ?? PivotMaxRows.DEFAULT;
    this.pivot_text_overflow = model.pivot_text_overflow ?? PivotDefaultTextOverflow;
    this.pivot_alternating_row_color = model.pivot_alternating_row_color ?? false;
    this.pivot_font_size = model.pivot_font_size ?? null;
  }
}
